export default {
  "width": 2400,
  "height": 3600,
  "yUnit": 50,
  "xUnit": 80,
  "minWidth": 1000,
  "bgColor": "#f2e9b8",
  "padding": [200, 200],
  "textColor": "#000000",
  "fontFamily": "OpenSans, sans-serif",
  "fontSize": 13,
  "fontWeight": "normal",
  "maxLines": 32,
  "maxPointsPerLine": 32,
  "minTextLength": 1,
  "maxTextLength": 24,
  "pathInterpolation": "basis", // linear, basis, cardinal, monotone
  "pointColor": "#ffffff",
  "pointColorInverse": "#444444",
  "borderColor": "#444444",
  "borderColorInverse": "#ffffff",
  "borderWidth": 2,
  "borderRadius": 4,
  "cornerRadius": 40,
  "pointRadius": 4,
  "pointRadiusLarge": 10,
  "strokeWidth": 8,
  "strokeOpacity": 0.9,
  "offsetWidth": 12,
  "minXDiff": 5,
  "hubSize": 4,
  "animate": true,
  "animationDuration": 2000,
  "colors": [
    {"hex":"#E5303C","group":"red"},
    {"hex":"#F6802C","group":"orange"},
    {"hex":"#FEC91A","group":"yellow"},
    {"hex":"#45A844","group":"green"},
    {"hex":"#3D84CA","group":"blue"},
    {"hex":"#C1477F","group":"violet"},
    {"hex":"#A59D90","group":"gray"},
    {"hex":"#F4897F","group":"red"},
    {"hex":"#FFA769","group":"orange"},
    {"hex":"#FFD45C","group":"yellow"},
    {"hex":"#74C063","group":"green"},
    {"hex":"#86D0ED","group":"blue"},
    {"hex":"#BF6992","group":"violet"},
    {"hex":"#BAB4AA","group":"gray"},
    {"hex":"#D8448B","group":"red"},
    {"hex":"#E57257","group":"orange"},
    {"hex":"#FCAB1D","group":"yellow"},
    {"hex":"#45A384","group":"green"},
    {"hex":"#6285D1","group":"blue"},
    {"hex":"#9975BC","group":"violet"},
    {"hex":"#999082","group":"gray"},
    {"hex":"#EA83B9","group":"red"},
    {"hex":"#E28876","group":"orange"},
    {"hex":"#FFD773","group":"yellow"},
    {"hex":"#75BCA2","group":"green"},
    {"hex":"#85A5DD","group":"blue"},
    {"hex":"#AB90C4","group":"violet"},
    {"hex":"#CCC6BE","group":"gray"},
    {"hex":"#E05865","group":"red"},
    {"hex":"#EA965C","group":"orange"},
    {"hex":"#F4D069","group":"yellow"},
    {"hex":"#73AA72","group":"green"},
    {"hex":"#5D98C9","group":"blue"},
    {"hex":"#D162A4","group":"violet"},
    {"hex":"#A09D9A","group":"gray"}
  ],
  "legend": {
    "padding": 40,
    "bgColor": "#e8ddc2",
    "columns": 2,
    "columnThreshold": 12,
    "columnWidth": 320,
    "titleFontSize": 24,
    "titleMaxLineChars": 30,
    "titleLineHeight": 30,
    "fontSize": 14,
    "lineHeight": 30,
    "gridUnit": 20
  },
  "pathTypes": [
    {"xDirection":"s","directions":["s"]}, // straight line
    {"xDirection":"e","directions":["s","e","s"]}, // elbow right
    {"xDirection":"w","directions":["s","w","s"]}, // elbow left
  ]
}




// WEBPACK FOOTER //
// ./src/config.js